<template>
  <span v-if="entries.length" class="error-cat-wrap">
    <i
      :id="icon_id"
      class="fa fa-exclamation-triangle error-cat-icon"
      tabindex="0"
      role="button"
      aria-label="Hover or click for error explanation"
      @click.stop
    ></i>
    <b-popover
      :target="icon_id"
      triggers="hover click focus blur"
      :delay="{ show: 100, hide: 200 }"
      placement="right"
      boundary="window"
      container="body"
      custom-class="error-cat-popover"
    >
      <div v-for="(entry, idx) in entries" :key="idx" class="error-cat-entry">
        <div class="error-cat-title">{{ entry.definition.category }}</div>
        <div class="error-cat-group">{{ entry.group_label }}</div>
        <div class="error-cat-line"><b>Error:</b> {{ entry.message }}</div>
        <div class="error-cat-line"><b>What it means:</b> {{ entry.definition.explanation }}</div>
        <div class="error-cat-line error-cat-fix"><b>Suggested fix:</b> {{ entry.definition.suggested_fix }}</div>
      </div>
    </b-popover>
  </span>
</template>

<script>
import {categorizeError, GROUP_LABELS} from '../helpers/actuals_error_categories'

export default {
  name: 'error_category_popover',

  props: {
    // raw error message fragment, may contain HTML and multiple errors joined with '|'
    message: {
      type: String,
      default: '',
    },
    // which actuals pipeline emitted the error: 'cm', 'fasttrak', or 'tbn'
    source: {
      type: String,
      default: 'cm',
    },
  },

  computed: {
    icon_id() {
      return `error-cat-icon-${this._uid}`
    },
    entries() {
      const text = String(this.message || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
      if (!text)
        return []
      // TBN joins multiple errors with ' | ' in a single status message
      const parts = text.split('|').map(part => part.trim()).filter(part => part.length > 0)
      return parts.map(part => {
        const definition = categorizeError(part, this.source)
        return {
          message: part,
          definition,
          group_label: GROUP_LABELS[definition.group] || definition.group,
        }
      })
    },
  },
}
</script>

<style>
.error-cat-icon {
  color: #dc3545;
  cursor: pointer;
  margin-right: 5px;
  font-size: 13px;
  vertical-align: middle;
}
.error-cat-icon:hover,
.error-cat-icon:focus {
  color: #a71d2a;
  outline: none;
}
/* popover renders outside this component, so styles must not be scoped */
.error-cat-popover {
  max-width: 420px;
  text-align: left;
  font-size: 13px;
  line-height: 1.45;
  z-index: 1100;
}
.error-cat-popover .popover-body {
  padding: 10px 12px;
}
.error-cat-entry + .error-cat-entry {
  border-top: 1px solid #ddd;
  margin-top: 8px;
  padding-top: 8px;
}
.error-cat-title {
  font-weight: bold;
  font-size: 14px;
  color: #721c24;
}
.error-cat-group {
  font-style: italic;
  color: #555;
  margin-bottom: 4px;
}
.error-cat-line {
  margin-bottom: 3px;
}
.error-cat-fix {
  color: #155724;
}
</style>
